import React from "react"
import ValuesPhilosophyImg from "../../images/team-values.svg"

const Pilosophy = () => {
  return (
    <section className="container mx-auto px-6 pb-6 w-full">
      <h2 className="text-center text-5xl md:text-6xl font-bold pb-4 md:px-0 text-secondary">
        Values <span className="text-primary">&</span> Philosophy   
      </h2>
      <h3 className="text-4xl text-center font-medium pb-4">Define our quality</h3>
      <p className="text-center pb-8 text-lg w-full lg:w-3/4 xl:w-1/2 mx-auto">For each project, we carry out a <b>360-degree analysis</b>. Then, we create customized teams that focus on the needs and requirements of each client, and <b>ensure quality</b> through our work culture.</p>

      <img src={ValuesPhilosophyImg} alt="Values & Philosophy" className="mx-auto py-8" /> 

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-4 gap-x-16 text-3xl text-center pt-8 pb-20">
        <div className="border-2 border-red-600 mb-4 rounded-2xl py-3 bg-secondary text-white">Adaptable</div>
        <div className="border-2 border-black mb-4 rounded-2xl py-3">Innovative</div>
        <div className="border-2 border-black mb-4 rounded-2xl py-3">Inclusive</div>
        <div className="border-2 border-black mb-4 rounded-2xl py-3">Fellows</div>
        <div className="border-2 border-black mb-4 rounded-2xl py-3">Collaborative</div>
        <div className="border-2 border-red-600 mb-4 rounded-2xl py-3 bg-secondary text-white">Committed</div>
      </div>
    </section>
  )
}

export default Pilosophy
